module.exports = __webpack_public_path__ + "img/partner13.6fdf0c06.png";